import { Component, OnInit, Input, Output, ViewChild, ElementRef, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take, finalize } from 'rxjs/operators';

import { StoreService } from '../../../stores/services/store.service';

@Component({
  selector: 'app-dialog-search-siret',
  templateUrl: './dialog-search-siret.component.html',
  styleUrls: ['./dialog-search-siret.component.sass']
})
export class DialogSearchSiretComponent implements OnInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('form') form: NgForm;

  error: any = false;
  searching = false;
  submitted = false;
  searchFormShown = false;
  model = {
    siret: '' // 82172557900014
  };

  constructor(
    private storeService: StoreService,
    private router: Router,
    public dialogRef: MatDialogRef<DialogSearchSiretComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

  onAdd() {
    this.searchFormShown = true;

    setTimeout(_ => {
      this.searchInput.nativeElement.focus();
    });
  }

  onCancel() {
    this.searchFormShown = false;
    this.dialogRef.close(false);
  }

  onSubmit(form) {
    const { siret } = this.model;

    this.error = false;

    if (form.form.valid) {
        this.searching = true;

        this.storeService.searchBySiret(siret)
          .pipe(
            take(1),
            finalize(() => {
              this.searching = false;
            })
          )
          .subscribe(
            (response) => {
              if (response) {
                this.storeService.keepStore(response);
                this.router.navigate([ '/management/stores', response['siret'] ]);
                this.dialogRef.close();
              }
              this.error = 404;
            },
            (error) => {
              this.error = error.status;
              return false;
            }
          );
      }
  }
}
